import React from 'react';

const Showroom = () => {
    return (
        <div className="min-h-screen bg-gray-900">
            <iframe 
                // src="/bestseller_table copy 2.html" 
                src="/ss26_marketweek.html" 
                title="Showroom SS26 Market Week Sample"
                className="w-full h-screen"
                style={{ border: 'none' }}
            />
        </div>
    );
};

export default Showroom;

